import { debounce } from './default';

$(document).ready(() => {
  $('.js-logo-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 6000,
    autoplay: true,
    rows: 0,
    autoplaySpeed: 0,
    slidesToShow: 6,
    slidesToScroll: 1,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1470,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.js-team-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.js-carousel-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1469,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.js-carousel-slider-relationships .griditems').each(function () {
    $(this).slick({
      dots: false,
      infinite: true,
      speed: 300,
      rows: 0,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1469,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
});

// eslint-disable-next-line prefer-arrow-callback
document.addEventListener('live-pricing-done', function () {
  console.log('live pricing has just finished running');
  /**
   * Remove placeholder tiles from relationships
   */
  (() => {
    document.querySelectorAll('.productsrelated_container .tileparent_placeholder').forEach((item) => {
      item.remove();
    });
  })();
  $('.js-carousel-slider-relationships .griditems').each(function () {
    $(this).slick('refresh');
  });
}, false);

function saveInput() {
  $('.js-carousel-slider-relationships .griditems').each(function () {
    /**
   * Remove placeholder tiles from relationships
   */
    (() => {
      document.querySelectorAll('.productsrelated_container .tileparent_placeholder').forEach((item) => {
        item.remove();
      });
    })();
    $(this).slick('refresh');
  });
}
const processChange = debounce(() => saveInput());

window.addEventListener('resize', () => {
  processChange();
});
